module.exports = __webpack_public_path__ + "img/cards.2567a070.png";